import { Injectable } from '@angular/core';
import { Customer, SelectedCustomerService } from 'gung-standard';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloCustomerUtilsService {
  isTylo = environment.projectName === 'tylo';

  constructor(protected selectedCustomerService: SelectedCustomerService) {}

  public isSelectedCustomerExport(customer: Customer): boolean {
    if (this.isTylo) {
      const kusMomskod = customer.extra.kus.momskod; // momskod
      return 1 !== kusMomskod;
    } else {
      // Talked to Julia https://gung-se.freshdesk.com/a/tickets/109142
      // Customer id startsWith D - Domestic / E - Export
      return customer.id.startsWith('E');
      //     const kusMomskod = customer.extra.kus.momskod; // momskod
      //     return (11 !== kusMomskod);
    }
  }

  public shouldFreightByApplied(customer: Customer, levvillkkod: number): boolean {
    // Never apply freight on export customers
    if (this.isSelectedCustomerExport(customer)) {
      console.log('customer is export - no freight');
      return false;
    }
    // Special deliveryterm used by bastuspecialisten in sweden, changed to 99 if they change deliver address
    if (this.isTylo && levvillkkod === 1 /*  || levvillkkod === 3 */) {
      return false;
    }
    return true;
  }

  public isFreightConditional(customer: Customer): boolean {
    // Special deliveryterm used by bastuspecialisten in sweden, changed to 99 if they change deliver address
    if (this.isTylo && (customer.extra.kus.levvillkkod === 1 || customer.extra.kus.levvillkkod === 3)) {
      return true;
    }
    return false;
  }

  public isPhoneNumberMandatory(): boolean {
    return false;
  }

  public getCustomerVATCode(customer: Customer): string {
    return customer.extra.kus.momskod; // momskod
  }
}
